import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { getUsers } from 'api/users/getUsers'
import { usersQueryKeyWithParams } from './keys'

export const useUsersQuery = (request: Parameters<typeof getUsers>[0]) => {
  return useQuery({
    queryKey: usersQueryKeyWithParams(Object.values(request)),
    queryFn: () => getUsers(request),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 60 * 5, // 5 hours
    gcTime: 1000 * 60 * 60 * 5, // 5 hours
  })
}
